import styled from "styled-components";
import Contacts from "../ui/contacts/Contacts";
import Logo from "./Logo";

const Header = ({ windowWidth }) => {
  return (
    <StyledHeader>
      {windowWidth > 840 && <Logo />}
      <Contacts />
    </StyledHeader>
  );
};

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 120px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  gap: 20px;
`;

export default Header;
